// extracted by mini-css-extract-plugin
module.exports = {"n42g2uh":"n42g2uh","mvx6ond":"mvx6ond","dgoq134":"dgoq134","mzm2401":"mzm2401"};